import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Player } from './videoModal.styles';
import { ModalContainer } from '../../modal/modalContainer/';
import { PlatformDetector } from '../../platformDetector/platformDetector.component';

export class VideoModal extends PureComponent {
  static propTypes = {
    videoId: PropTypes.string,
    videoHost: PropTypes.string,
    closeVideo: PropTypes.func.isRequired,
  };

  render() {
    const { videoId, closeVideo, videoHost } = this.props;
    if (!videoId || !videoHost) { return null; }
    return (
      <ModalContainer isOpen={!!videoId} onClose={closeVideo}>
        <PlatformDetector>
          {
            ({ activeResolution }) => (
              <Player
                videoId={videoId}
                videoHost={videoHost}
                className={`player--${activeResolution}`}
                autoplay={true}
              />
            )
          }
        </PlatformDetector>
      </ModalContainer>
    );
  }
}
